import { Injectable } from '@angular/core';
declare let Plotly: any;

@Injectable({
  providedIn: 'root',
})
export class PlotlyService {
  constructor() {}

  mobileGraphConfig = {
    displaylogo: false,
    scrollZoom: false,
    modeBarButtonsToRemove: ['lasso2d','select2d', 'autoscale']
  }

  // Method to plot a line and scatter
  generateMobileSimpleWithoutWaitTimeGraph(title: string, plotDiv: string, x: any[], y: number[], x1: any[], y1: number[], x_name: any, y_name: any, text: any, text1: any) {
    const trace1 = {
      x: x,
      y: y,
      name: '',
      mode: 'lines+markers',
      text: text,
      hovertemplate: '<b>Endpoint Name - %{text.endPointName}</b><br><b>Instruction Name - %{text.instructionName}</b><br>Status - %{text.executionStatus}<br>Duration - %{text.durationInSeconds}',
      type: 'bar',
    };

    const trace2 = {
      x: x1,
      y: y1,
      mode: 'markers',
      text: text1,
      hovertemplate: '<b>Endpoint Name - %{text.endPointName}</b><br><b>Instruction Name - %{text.instructionName}</b><br>Status - %{text.executionStatus}<br>Duration - %{text.durationInSeconds}',
      type: 'scatter',
    };

    const data = [trace1, trace2];

    const layout = {
      title: {
        text : title
      },
      showlegend: false,
      xaxis: {
        title: {
          text: x_name,
        },
      },
      yaxis: {
        title: {
          text: y_name,
        }
      },
    };

    Plotly.newPlot(plotDiv, data, layout, this.mobileGraphConfig).then(() => {
      console.log('Plotly plot has been rendered!');
    }).catch(err => {
      console.error('Error rendering plot:', err);
    });
  }

  // Method to plot a line and scatter
  generateMobileCumulativeWithoutWaitTime(title: string, plotDiv: string, x: any[], y: number[], x1: any[], y1: number[], x_name: any, y_name: any, text: any, text1:any) {
    const trace1 = {
      x: x,
      y: y,
      name: '',
      mode: 'lines',
      text: text,
      hovertemplate: '<b>Endpoint Name - %{text.endPointName}</b><br><b>Instruction Name - %{text.instructionName}</b><br>Status - %{text.executionStatus}<br>Duration - %{text.durationInSeconds}',
      type: 'scatter',
    };

    const trace2 = {
      x: x1,
      y: y1,
      name: '',
      mode: 'lines+markers',
      text: text,
      hovertemplate: '<b>Endpoint Name - %{text.endPointName}</b><br><b>Instruction Name - %{text.instructionName}</b><br>Status - %{text.executionStatus}<br>Duration - %{text.durationInSeconds}',
      type: 'scatter',
    };

    const data = [trace1, trace2];

    const layout = {
      title: {
        text : title
      },
      showlegend: false,
      xaxis: {
        title: {
          text: x_name,
        },
      },
      yaxis: {
        title: {
          text: y_name,
        }
      }
    };

    Plotly.newPlot(plotDiv, data, layout, this.mobileGraphConfig).then(() => {
      console.log('Plotly plot has been rendered!');
    }).catch(err => {
      console.error('Error rendering plot:', err);
    });
  }

  // Method to plot a bar chart
  generateSimpleMobilePerformanceGraph(title: string, plotDiv: string, x: number[], y: number[], x_name: any, y_name: any, text: any) {
    const trace = {
      x: x,
      y:  y,
      name: '',
      type: 'bar',
      text: text,
      hovertemplate: '<b>Endpoint Name - %{text.endPointName}</b><br><b>Instruction Name - %{text.instructionName}</b><br>Status - %{text.executionStatus}<br>Duration - %{text.durationInSeconds}',
      mode: 'lines+markers',
    };

    const layout = {
      title: {
        text : title
      },
      showlegend: false,
      xaxis: {
        title: {
          text: x_name,
        },
      },
      yaxis: {
        title: {
          text: y_name,
        }
      }
    };

    Plotly.newPlot(plotDiv, [trace], layout, this.mobileGraphConfig).then(() => {
      console.log('Plotly plot has been rendered!');
    }).catch(err => {
      console.error('Error rendering plot:', err);
    });
  }

  // Method to pie
  generateSimplePerformancePie(title: string, plotDiv: string, data: any) {
    const layout = {
      autosize: false,
      width: 350,
      height: 300,
      margin: {
        l: 50,
        r: 50,
        b: 0,
        t: 10,
        pad: 2
      },
      showlegend: true,
      legend: {
        x: 1,
        y: 0.5
      }
    };

    Plotly.newPlot(plotDiv, data, layout, { displaylogo: false, scrollZoom: false, modeBarButtonsToRemove: ['lasso2d','select2d'] }).then(() => {
      console.log('Plotly plot has been rendered!');
    }).catch(err => {
      console.error('Error rendering plot:', err);
    });
  }

  // Method to pie
  generateSimplePerformanceBar(title: string, plotDiv: string, data: any) {
    const layout = {
      title: {
        text : title
      },
      showlegend: false,
    };

    Plotly.newPlot(plotDiv, data, layout, { displaylogo: false, scrollZoom: false, modeBarButtonsToRemove: ['lasso2d','select2d'] }).then(() => {
      console.log('Plotly plot has been rendered!');
    }).catch(err => {
      console.error('Error rendering plot:', err);
    });
  }

  // Method to plot a bar chart
  generateSimplePerformanceBarGraph(title: string, plotDiv: string, x: number[], y: number[], x_name: any, y_name: any, text: any) {
    const trace = {
      x: x,
      y:  y,
      name: '',
      type: 'bar',
      text: text,
      mode: 'lines+markers',
    };

    const layout = {
      title: {
        text : title
      },
      colorway : ['#f3cec9', '#e7a4b6', '#cd7eaf', '#a262a9', '#6f4d96', '#3d3b72', '#182844'],
      showlegend: false,
      xaxis: {
        title: {
          text: x_name,
        },
      },
      yaxis: {
        title: {
          text: y_name,
        }
      }
    };

    Plotly.newPlot(plotDiv, [trace], layout, { displaylogo: false, scrollZoom: false, modeBarButtonsToRemove: ['lasso2d','select2d'] }).then(() => {
      console.log('Plotly plot has been rendered!');
    }).catch(err => {
      console.error('Error rendering plot:', err);
    });
  }

  // Method to plot a line and scatter
  generateSimpleLineGraph(title: string, plotDiv: string, x: any[], y: number[], x_name: any, y_name: any, text: any) {
    const trace1 = {
      x: x,
      y: y,
      name: '',
      mode: 'lines+markers',
      text: text,
      type: 'scatter',
    };

    const data = trace1;

    const layout = {
      title: {
        text : title
      },
      showlegend: false,
      xaxis: {
        title: {
          text: x_name,
        },
      },
      yaxis: {
        title: {
          text: y_name,
        }
      },
    };

    Plotly.newPlot(plotDiv, [data], layout, { displaylogo: false, scrollZoom: false, modeBarButtonsToRemove: ['lasso2d','select2d'] }).then(() => {
      console.log('Plotly plot has been rendered!');
    }).catch(err => {
      console.error('Error rendering plot:', err);
    });
  }

}
